import { useMemo } from 'react';

interface PasswordStrength {
  score: number;
  strength: 'weak' | 'medium' | 'strong';
  criteria: {
    length: boolean;
    uppercase: boolean;
    lowercase: boolean;
    number: boolean;
    special: boolean;
  };
}

export function usePasswordStrength(password: string): PasswordStrength {
  return useMemo(() => {
    const criteria = {
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /[0-9]/.test(password),
      special: /[^A-Za-z0-9]/.test(password),
    };

    const score = Object.values(criteria).filter(Boolean).length;
    const strength: PasswordStrength['strength'] =
      score <= 2 ? 'weak' : score === 3 ? 'medium' : 'strong';

    return { score, strength, criteria };
  }, [password]);
}
